module.exports = __webpack_public_path__ + "img/zfcg_16.291d99c1.png";